<app-page-header
  title="Meine Aufträge"
  subtitle="Übersicht deiner Bestellungen und deren Status"
  icon="shopping_cart"
  variant="gradient">
</app-page-header>

<div class="apple-container apple-slide-up">
  <div class="apple-filters-card apple-card">
    <form class="filter-bar" (ngSubmit)="applyFilters()" autocomplete="off" novalidate>
      <div class="filter-fields-row">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Von</mat-label>
          <input matInput [matDatepicker]="fromPicker" [(ngModel)]="filterFromDate" name="fromDate"
            placeholder="TT.MM.JJJJ" />
          <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker startView="multi-year"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Bis</mat-label>
          <input matInput [matDatepicker]="toPicker" [(ngModel)]="filterToDate" name="toDate"
            placeholder="TT.MM.JJJJ" />
          <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker startView="multi-year"></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="filter-field status-field">
          <mat-label>Status</mat-label>
          <mat-select [(ngModel)]="filterStatus" name="status" placeholder="Status">
            <mat-option [value]="">Alle</mat-option>
            <mat-option *ngFor="let s of (statuses$ | async) || []" [value]="s">
              {{ s }}
            </mat-option>
          </mat-select>
          <button mat-icon-button matSuffix type="button" aria-label="Clear"
            (click)="filterStatus = ''; applyFilters()">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>

      </div>

      <div class="filter-controls-row">
        <div class="quick-ranges">
          <mat-button-toggle-group name="quickRange" [value]="quickRange" (change)="onQuickRangeChange($event.value)"
            aria-label="Schnellauswahl Zeitraum">
            <mat-button-toggle value="today">Heute</mat-button-toggle>
            <mat-button-toggle value="last7">Letzte 7 Tage</mat-button-toggle>
            <mat-button-toggle value="thisMonth">Dieser Monat (bis heute)</mat-button-toggle>
            <mat-button-toggle value="thisMonthFull">Dieser Monat (komplett)</mat-button-toggle>
            <mat-button-toggle value="last30">Letzte 30 Tage</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="filter-actions">
          <button mat-flat-button color="primary" type="submit" class="apple-button apple-button-primary">
            <mat-icon class="icon-vert-align">filter_list</mat-icon>
            <span>Filter anwenden</span>
          </button>
          <button mat-stroked-button type="button" (click)="resetFilters()" class="apple-button apple-button-secondary">
            <mat-icon class="icon-vert-align">refresh</mat-icon>
            <span>Zurücksetzen</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="apple-container">
  <div class="apple-orders-card apple-card">
    <mat-tab-group class="apple-tabs" animationDuration="300ms">
      <!-- Current Orders Tab -->
      <mat-tab label="Aktuelle Aufträge">
        <div class="tab-content">

          <div class="apple-orders-table-card">
            <table class="apple-orders-table">
              <thead>
                <tr class="apple-table-header-row">
                  <th>Auftragsnr.</th>
                  <th>Zeitraum</th>
                  <th>Coins</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of currentOrders$ | async" class="apple-table-row">
                  <td>{{ order.orderNo }}</td>
                  <td>{{ order.dateFrom | date:'dd.MM.yyyy' }} - {{ order.dateTo | date:'dd.MM.yyyy' }}</td>
                  <td>
                    <span class="coins-display">
                      @if (getCoinsUsed(order.orderNo) > 0) {
                        <mat-icon class="coins-icon">monetization_on</mat-icon>
                        <span class="coins-amount">{{ getCoinsUsed(order.orderNo) }}</span>
                      } @else {
                        <span class="coins-none">0</span>
                      }
                    </span>
                  </td>
                  <td>
                    <button mat-flat-button class="apple-button apple-button-primary apple-button-small" [routerLink]="['./', order.orderNo]">
                      <mat-icon>arrow_forward</mat-icon>
                      Details
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div *ngIf="(currentOrders$ | async)?.length === 0" class="empty-state">
              <mat-icon>inbox</mat-icon>
              <p>Keine aktuellen Aufträge vorhanden</p>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Completed Orders Tab -->
      <mat-tab label="Abgeschlossene Aufträge">
        <div class="tab-content">
          <div class="tab-header">
            <mat-form-field appearance="outline" class="year-filter">
              <mat-label>Jahr</mat-label>
              <mat-select [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event.value)">
                <mat-option *ngFor="let year of availableYears" [value]="year">
                  {{ year }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="apple-orders-table-card">
            <table class="apple-orders-table">
              <thead>
                <tr class="apple-table-header-row">
                  <th>Auftragsnr.</th>
                  <th>Zeitraum</th>
                  <th>Coins</th>
                  <th>Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of completedOrders$ | async" class="apple-table-row">
                  <td>{{ order.orderNo }}</td>
                  <td>{{ order.dateFrom | date:'dd.MM.yyyy' }} - {{ order.dateTo | date:'dd.MM.yyyy' }}</td>
                  <td>
                    <span class="coins-display">
                      @if (getCoinsUsed(order.orderNo) > 0) {
                        <mat-icon class="coins-icon">monetization_on</mat-icon>
                        <span class="coins-amount">{{ getCoinsUsed(order.orderNo) }}</span>
                      } @else {
                        <span class="coins-none">0</span>
                      }
                    </span>
                  </td>
                  <td>
                    <button mat-flat-button class="apple-button apple-button-primary apple-button-small" [routerLink]="['./', order.orderNo]">
                      <mat-icon>arrow_forward</mat-icon>
                      Details
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div *ngIf="(completedOrders$ | async)?.length === 0" class="empty-state">
              <mat-icon>inbox</mat-icon>
              <p>Keine abgeschlossenen Aufträge für {{ selectedYear }}</p>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
